// extracted by mini-css-extract-plugin
module.exports = {"content":"Customize_content__2TB0C","title":"Customize_title__FMb-u","componey":"Customize_componey__1jOiK","desc":"Customize_desc__2kXaV"};